import { FC } from 'react';
import { useDispatch } from 'react-redux';

import { PayloadAction } from '@reduxjs/toolkit';
import { Button } from 'antd';
import cs from 'classnames';

import { Application } from 'types/applications';
import { Client } from 'types/clients';
import { Job } from 'types/jobs';
import { Jobseeker } from 'types/jobseekers';
import { RecruitmentOverviewReportJob } from 'types/reports';

import { ReactComponent as ArrowIcon } from 'assets/icons/arrowDown.svg';

import { useTranslation } from 'react-i18next';
import styles from './SidebarNavigation.module.scss';

interface SidebarNavigationProps {
  id: string;
  data: Array<
    Client | Job | Jobseeker | Application | RecruitmentOverviewReportJob
  >;
  isContainerStyles?: boolean;
  action: (id: string) => PayloadAction<string>;
}

const SidebarNavigation: FC<SidebarNavigationProps> = ({
  id,
  data,
  isContainerStyles = true,
  action
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation()

  const handlePrevClick = () => {
    const currentIndex = data.findIndex((item) => item.id === id);
    if (currentIndex > 0) {
      const prevItem = data[currentIndex - 1];
      dispatch(action(prevItem.id));
    }
  };

  const handleNextClick = () => {
    const currentIndex = data.findIndex((item) => item.id === id);
    if (currentIndex < data.length - 1) {
      const nextItem = data[currentIndex + 1];
      dispatch(action(nextItem.id));
    }
  };

  const currentIndex = data.findIndex((item) => item.id === id);

  return (
    <div className={cs({ [styles.container]: isContainerStyles })}>
      <Button
        type="link"
        icon={<ArrowIcon />}
        onClick={handlePrevClick}
        disabled={currentIndex <= 0}
        className={cs(styles.button, styles.prevButton)}
      >
        {t('sidebar.nav.previous')}
      </Button>
      <Button
        type="link"
        icon={<ArrowIcon />}
        iconPosition="end"
        onClick={handleNextClick}
        disabled={currentIndex >= data.length - 1}
        className={cs(styles.button, styles.nextButton)}
      >
        {t('sidebar.nav.next')}
      </Button>
    </div>
  );
};

export default SidebarNavigation;
